import React, { Component, Children } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import cls from './index.scss'

export const PaneDeprecated = ({ children, className }) => (
  <div className={cx(cls.pane, className)}>{children}</div>
)

const selectedType = PropTypes.oneOfType([PropTypes.number, PropTypes.string])

// These are used later in the Tabs component via React.Children
/* eslint-disable react/no-unused-prop-types */
PaneDeprecated.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  id: selectedType,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.string,
}
/* eslint-enable react/no-unused-prop-types */

export class TabsDeprecated extends Component {
  static propTypes = {
    role: PropTypes.oneOf(['primary', 'secondary']),
    selected: selectedType,
    orientation: PropTypes.oneOf(['horizontal', 'vertical']),
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    cls: PropTypes.object.isRequired,
    onSelect: PropTypes.func,
    elmId: PropTypes.string,
  }

  static defaultProps = {
    role: 'primary',
    selected: null,
    orientation: 'horizontal',
    elmId: 'tabs',
    cls: {},
    onSelect: () => undefined,
  }

  _renderTab = pane => {
    const { cls: extcls, selected } = this.props
    const { id, label, disabled, title } = pane.props

    const className = cx(
      cls.tab,
      extcls.tab,
      selected === id && [cls['is-selected'], extcls.tabSelected],
      disabled && cls['is-disabled']
    )

    return (
      <li
        key={id}
        title={title}
        data-elm-id={`${this.props.elmId}_${id}`}
        className={className}
        onClick={() => !disabled && this._select(id)}
      >
        {label}
      </li>
    )
  }

  _select(id) {
    this.props.onSelect(id)
  }

  render() {
    const {
      children,
      role,
      orientation,
      className,
      selected,
      cls: extcls,
      elmId,
    } = this.props
    const childrenArr = Children.toArray(children)

    return (
      <div className={cx(cls.root, className)} data-elm-id={elmId}>
        <ul
          className={cx(
            cls.tabs,
            cls[`orientation-${orientation}`],
            cls[`role-${role}`],
            extcls.tabs
          )}
        >
          {childrenArr.map(this._renderTab)}
        </ul>
        {childrenArr.find(pane => pane.props.id === selected)}
      </div>
    )
  }
}
